import { render, staticRenderFns } from "./_materialPage.vue?vue&type=template&id=50b7718b&"
import script from "./_materialPage.vue?vue&type=script&lang=js&"
export * from "./_materialPage.vue?vue&type=script&lang=js&"
import style0 from "./_materialPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports